import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tier",
  "use": "icon-tier-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tier\"><defs><style type=\"text/css\"></style></defs><path d=\"M881 610l31 66-408 229-392-212 29-67 363 196 377-212z m2-167l29 67-409 227-391-210 29-68 362 195 380-211zM512 130l400 229-406 228-394-210 400-247z\" p-id=\"16028\" data-spm-anchor-id=\"a313x.7781069.0.i27\" class=\"selected\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol